import { QuestionBase } from '@app/core/models/question/question-base';

export class TextboxQuestion extends QuestionBase<string> {
  controlType = 'textbox';
  type: string;

  constructor(options: any = {}) {
    super(options);
    this.type = options['type'] || 'text';
  }
}




// WEBPACK FOOTER //
// ./src/app/core/models/question/textbox-question.ts